import { GridApi } from 'ag-grid-enterprise';

export function syncNoRowsOverlay(api: GridApi) {
  queueMicrotask(() => {
    const count = api.getDisplayedRowCount();
    if (count === 0) api.showNoRowsOverlay();
    else api.hideOverlay();
  });
}
